import { FC, useState } from 'react';

import { Box, Button, Stack } from '@mui/material';
import { Form, Formik } from 'formik';

import { SearchInput } from 'src/components/SearchInput';
import { showErrorToast, showSuccessToast } from 'src/components/Toasts/toast';
import { useEmailAddressValidation } from 'src/utils/validateEmail';

import { editEmailValidation } from '../validation/editEmail';

interface EditEmailFormProps {
    email: string;
    loading: boolean;
    updateUser: (args) => void;
    handleClose: () => void;
}

const EditEmailForm: FC<EditEmailFormProps> = ({ email, loading, updateUser, handleClose }) => {
    const [emailIsValid, setEmailIsValid] = useState<boolean>(true);
    const { isEmailAddressValid } = useEmailAddressValidation();
    const handleValidateEmail = async (email: string) => {
        const isEmailAValid = await isEmailAddressValid(email);
        if (isEmailAValid) {
            showSuccessToast('Email is valid');
            setEmailIsValid(true);
        } else {
            showErrorToast('Email is not valid');
            setEmailIsValid(false);
        }
    };

    const EDIT_EMAIL_INITIAL_VALUES = {
        email: email || '',
    };

    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Formik
                initialValues={EDIT_EMAIL_INITIAL_VALUES}
                validationSchema={editEmailValidation}
                onSubmit={(values) => {
                    updateUser({
                        email: values.email,
                    });
                }}
            >
                {(formikProps) => {
                    const { values, errors, handleChange, isValid, dirty } = formikProps;
                    return (
                        <Form>
                            <SearchInput
                                name="email"
                                label="Email Address"
                                value={values.email}
                                onChange={handleChange}
                                error={
                                    errors.email || !emailIsValid
                                        ? errors.email ?? 'Email is Invalid'
                                        : undefined
                                }
                                boxStyling={{ width: '100%' }}
                                searchText="Validate Email"
                                onSearch={handleValidateEmail}
                            />
                            <Stack
                                direction="row"
                                justifyContent="flex-end"
                                spacing={2}
                                sx={{ my: 3 }}
                            >
                                <Button
                                    variant="outlined"
                                    onClick={handleClose}
                                    sx={{
                                        borderColor: '#000',
                                        color: '#000',
                                        '&:hover': {
                                            bgcolor: '#000',
                                            color: '#fff',
                                            opacity: 0.8,
                                        },
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    disabled={loading || !isValid || !dirty || !emailIsValid}
                                    color="primary"
                                    sx={{
                                        bgcolor: '#000',
                                        color: '#fff',
                                        '&:hover': {
                                            bgcolor: '#000',
                                            color: '#fff',
                                            opacity: 0.8,
                                        },
                                    }}
                                >
                                    {loading ? 'Updating' : 'Update'}
                                </Button>
                            </Stack>
                        </Form>
                    );
                }}
            </Formik>
        </Box>
    );
};

export default EditEmailForm;
